import { useCallback, useMemo, useState } from 'react'
import { studentsStore } from '../../model/studentsStore'

export const useViewStudents = ({
	onOpenSendMessage,
	onOpenAssignActivity,
	// onOpenBookSession,
} = {}) => {
	const students = studentsStore.filteredStudents
	const selectedIds = studentsStore.selectedStudentIds
	const sortKey = studentsStore.sortKey
	const sortDir = studentsStore.sortDir
	const view = studentsStore.view
	// const defaultNamberList = studentsStore?.savedLists?.length
	// 	? studentsStore.savedLists.length + 1
	// 	: 1
	const defaultNamberList = 1

	const [nameList, setNameList] = useState(`My List ${defaultNamberList}`)
	const [isOpenModalNameList, setIsOpenModalNameList] = useState(false)
	const [errNameList, setErrNameList] = useState(null)

	const allSelected =
		students.length > 0 && selectedIds.length === students.length

	const hasSelection = studentsStore.hasSelection
	const selectedCount = studentsStore.selectedCount

	const selectionText = useMemo(() => {
		if (!hasSelection) return ''
		if (selectedCount === 1) return '1 student selected'
		return `${selectedCount} students selected`
	}, [hasSelection, selectedCount])

	const handleToggleOne = useCallback(id => {
		studentsStore.toggleStudentSelection(id)
	}, [])

	const handleToggleAll = useCallback(() => {
		const ids = students.map(s => s.id)
		studentsStore.selectAllForCurrentList(ids)
	}, [students])

	const handleClearSelection = useCallback(() => {
		studentsStore.clearSelection()
	}, [])

	const handleSendMessage = useCallback(() => {
		if (!studentsStore.hasSelection) return

		const recipients = studentsStore.selectedStudents

		onOpenSendMessage?.({
			recipients,
			recipientIds: recipients.map(r => r.id),
			selectedCount: studentsStore.selectedCount,
		})
	}, [onOpenSendMessage])

	const handleAssignActivity = useCallback(() => {
		if (!studentsStore.hasSelection) return
		onOpenAssignActivity?.()
	}, [onOpenAssignActivity])

	// const handleBookSession = useCallback(() => {
	// 	if (!studentsStore.hasSelection) return
	// 	onOpenBookSession?.()
	// }, [onOpenBookSession])

	const handleSort = useCallback((key, dir) => {
		studentsStore.setSort(key, dir)
	}, [])

	// const handleSaveList = useCallback(() => {
	// 	if (!studentsStore.hasSelection) return

	// 	const nextIndex = studentsStore?.savedLists?.length
	// 		? studentsStore.savedLists.length + 1
	// 		: 1

	// 	setNameList(`My List ${nextIndex}`)
	// 	setIsOpenModalNameList(true)
	// }, [])

	const acceptNameHandler = useCallback(() => {
		const name = String(nameList || '').trim()
		if (!name) {
			setErrNameList('List name is required')
			return
		}

		studentsStore.saveCurrentSelectionAsList(name)
		setIsOpenModalNameList(false)
	}, [nameList])

	const changeNameListHandler = useCallback(value => {
		setNameList(value)
		setErrNameList(null)
	}, [])

	const actions = useMemo(() => {
		return [
			{
				id: 'send',
				label: 'Send Message',
				iconName: 'message',
				onClick: handleSendMessage,
			},
			{
				id: 'assignActivity',
				label: 'Create Assignment',
				iconName: 'dock',
				onClick: handleAssignActivity,
			},
			// {
			// 	id: 'bookSession',
			// 	label: 'Book Session',
			// 	iconName: 'clock',
			// 	onClick: handleBookSession,
			// },
			// {
			// 	id: 'save',
			// 	label: 'Save List',
			// 	iconName: 'plus',
			// 	variant: 'secondary',
			// 	onClick: handleSaveList,
			// },
		]
	}, [handleSendMessage, handleAssignActivity])

	return {
		view,
		students,
		selectedIds,
		allSelected,
		hasSelection,
		selectionText,
		handleToggleOne,
		handleToggleAll,
		handleClearSelection,
		handleSendMessage,
		sortKey,
		sortDir,
		handleSort,
		//handleSaveList,
		acceptNameHandler,
		isOpenModalNameList,
		setIsOpenModalNameList,
		nameList,
		defaultNamberList,
		errNameList,
		changeNameListHandler,
		actions,
	}
}
